/* Blog — fileiras horizontais em loop contínuo
   Cada fileira gira sem fim: ao chegar no último card ela segue no primeiro,
   sem borda e sem fim visível. O truque é clonar o conjunto de cards até ele
   encher mais que a tela e depois "costurar" a posição do scroll: quando ela
   passa de um conjunto, voltamos um conjunto inteiro. Como o conteúdo se
   repete, o salto é invisível. */

(function () {
  'use strict';

  var EASE = 0.18; // quanto do caminho que falta é percorrido a cada quadro

  function Row(row, root) {
    this.root = root;
    this.track = row.querySelector('[data-blg-track]');
    this.prev = row.querySelector('[data-blg-prev]');
    this.next = row.querySelector('[data-blg-next]');
    if (!this.track) return;

    this.originals = [].slice.call(this.track.children);
    if (!this.originals.length) return;

    this.setW = 0;
    this.copies = 1;
    this.started = false;
    this.target = 0;
    this.raf = null;

    this.bind();
    this.build();
  }

  /* ---------- medidas ---------- */

  Row.prototype.gap = function () {
    var cs = window.getComputedStyle(this.track);
    return parseFloat(cs.columnGap || cs.gap) || 0;
  };

  // largura de UM conjunto original, contando o espaço entre os cards
  Row.prototype.measureSet = function () {
    var gap = this.gap();
    var w = 0;
    for (var i = 0; i < this.originals.length; i++) {
      w += this.originals[i].getBoundingClientRect().width + gap;
    }
    return w;
  };

  /* ---------- clonagem ---------- */

  Row.prototype.build = function () {
    var setW = this.measureSet();
    if (!setW) return;

    var view = this.track.clientWidth;
    // Precisamos de um conjunto antes e um depois da área visível para poder
    // costurar os dois lados sem o usuário ver o fim da fila.
    var want = Math.ceil(view / setW) + 2;
    if (want < 3) want = 3;

    if (want !== this.copies) {
      while (this.track.children.length > this.originals.length) {
        this.track.removeChild(this.track.lastElementChild);
      }
      var frag = document.createDocumentFragment();
      for (var c = 1; c < want; c++) {
        for (var i = 0; i < this.originals.length; i++) {
          var clone = this.originals[i].cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          // leitores de tela e o Tab ignoram as cópias
          [].forEach.call(clone.querySelectorAll('a'), function (a) {
            a.setAttribute('tabindex', '-1');
          });
          frag.appendChild(clone);
        }
      }
      this.track.appendChild(frag);
      this.copies = want;
    }

    this.setW = this.measureSet();

    if (!this.started && this.setW) {
      this.started = true;
      this.track.scrollLeft = this.setW; // começa no segundo conjunto
      this.target = this.setW;
    }
  };

  /* ---------- costura ---------- */

  Row.prototype.shift = function (d) {
    this.track.scrollLeft += d;
    this.target += d; // mantém a distância que falta, para a animação seguir
  };

  Row.prototype.wrap = function () {
    if (!this.setW || !this.started) return;
    var x = this.track.scrollLeft;
    if (x >= this.setW * 2) this.shift(-this.setW);
    else if (x < this.setW) this.shift(this.setW);
  };

  /* ---------- animação própria ----------
     Não usamos scroll-behavior:smooth porque ele briga com o salto da
     costura. Aqui a posição persegue um alvo, e a costura move os dois
     juntos — então o movimento nunca trava no meio. */

  Row.prototype.run = function () {
    // Sempre reinicia. Um quadro pendente que nunca disparou — aba em segundo
    // plano, por exemplo — deixaria as setas mortas para o resto da sessão.
    if (this.raf) window.cancelAnimationFrame(this.raf);
    var self = this;
    this.raf = window.requestAnimationFrame(function tick() {
      var cur = self.track.scrollLeft;
      var d = self.target - cur;
      if (Math.abs(d) < 0.5) {
        self.track.scrollLeft = self.target;
        self.raf = null;
        self.wrap();
        return;
      }
      self.track.scrollLeft = cur + d * EASE;
      self.wrap();
      self.raf = window.requestAnimationFrame(tick);
    });
  };

  Row.prototype.stop = function () {
    if (this.raf) { window.cancelAnimationFrame(this.raf); this.raf = null; }
    this.target = this.track.scrollLeft;
  };

  Row.prototype.step = function (dir) {
    var card = this.track.querySelector('.blg__card');
    if (!card) return;
    var w = card.getBoundingClientRect().width + this.gap();
    var perView = Math.max(1, Math.floor(this.track.clientWidth / w));
    this.target = this.track.scrollLeft + dir * w * perView;
    this.run();
  };

  /* ---------- eventos ---------- */

  Row.prototype.bind = function () {
    var self = this;

    if (this.prev) this.prev.addEventListener('click', function () { self.step(-1); });
    if (this.next) this.next.addEventListener('click', function () { self.step(1); });

    this.track.addEventListener('scroll', function () { self.wrap(); }, { passive: true });
    this.track.addEventListener('wheel', function () { self.stop(); }, { passive: true });
    this.track.addEventListener('touchstart', function () { self.stop(); }, { passive: true });

    if ('ResizeObserver' in window) {
      this.ro = new ResizeObserver(function () { self.build(); });
      this.ro.observe(this.track);
    }
    window.addEventListener('load', function () { self.build(); });
    window.requestAnimationFrame(function () { self.build(); });

    this.bindDrag();
  };

  Row.prototype.bindDrag = function () {
    var self = this;
    var dragging = false, moved = false, startX = 0, startScroll = 0;

    this.track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      self.stop();
      dragging = true; moved = false;
      startX = e.clientX;
      startScroll = self.track.scrollLeft;
    });

    this.track.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 4) {
        moved = true;
        self.root.classList.add('blg--dragging');
        try { self.track.setPointerCapture(e.pointerId); } catch (err) {}
      }
      if (moved) {
        e.preventDefault();
        self.track.scrollLeft = startScroll - dx;
        self.target = self.track.scrollLeft;
        // a costura durante o arraste reposiciona a origem junto
        var before = self.track.scrollLeft;
        self.wrap();
        startScroll += self.track.scrollLeft - before;
      }
    });

    function end(e) {
      if (!dragging) return;
      dragging = false;
      self.root.classList.remove('blg--dragging');
      self.target = self.track.scrollLeft;
      if (e && e.pointerId != null) {
        try { self.track.releasePointerCapture(e.pointerId); } catch (err) {}
      }
    }

    this.track.addEventListener('pointerup', end);
    this.track.addEventListener('pointercancel', end);
    this.track.addEventListener('pointerleave', end);

    this.track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    this.track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  };

  /* ---------- montagem ---------- */

  function mount(scope) {
    var roots = (scope || document).querySelectorAll('[data-blg]');
    [].forEach.call(roots, function (root) {
      if (root.dataset.blgReady === 'true') return;
      root.dataset.blgReady = 'true';
      [].forEach.call(root.querySelectorAll('[data-blg-row]'), function (row) {
        new Row(row, root);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { mount(); });
  } else {
    mount();
  }

  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });
})();
